import * as yup from "yup";

export const SendPriceSchema = yup.object().shape({
  firstName: yup.string().trim().required("First Name is required"),
  lastName: yup.string().trim().required("Last Name is required"),
  email: yup.string().trim().email("Invalid email").required("Email is required"),
  phone: yup.string().trim().required("Phone is required"),
});

export type SendPriceSchema = yup.InferType<typeof SendPriceSchema>;
